import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { DeleteForever } from "@mui/icons-material";
import { useNotify, useRecordContext, useRedirect } from "react-admin";
import { deleteSupplier } from "@/api/resources/suppliers";
import { TSupplier } from "@/api/types/supplier";

export const SupplierDeleteButton = () => {
  const record = useRecordContext<TSupplier>();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [typed, setTyped] = useState("");
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const name = record.name ?? "";
  const matches = typed.trim() === name.trim() && name.length > 0;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const report = await deleteSupplier(String(record.id), typed.trim());
      if (report.failures && report.failures.length > 0) {
        notify(
          `Proveedor eliminado, pero fallaron: ${report.failures.join("; ")}`,
          { type: "warning" }
        );
      } else {
        notify("Proveedor eliminado correctamente", { type: "success" });
      }
      setOpen(false);
      redirect("list", "suppliers");
    } catch (e: any) {
      notify(
        e?.response?.data?.message ?? "Error al eliminar el proveedor",
        { type: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        color="error"
        startIcon={<DeleteForever />}
        onClick={() => setOpen(true)}
      >
        Eliminar proveedor
      </Button>
      <Dialog open={open} onClose={() => !loading && setOpen(false)}>
        <DialogTitle sx={{ color: "error.main" }}>
          Eliminar proveedor
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Esta acción es <strong>irreversible</strong>. Se eliminarán el
            proveedor, sus clientes (sellers), sus productos y sus índices de
            búsqueda.
            <br />
            Para confirmar, escribe el nombre exacto del proveedor:{" "}
            <strong>{name}</strong>
          </DialogContentText>
          <TextField
            autoFocus
            fullWidth
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={name}
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={!matches || loading}
            onClick={handleConfirm}
          >
            {loading ? "Eliminando..." : "Eliminar definitivamente"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
